import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AttributeFilter } from './models/filter-models';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.modal.html',
  styleUrls: ['./filters.modal.scss'],
})
export class FiltersModal implements OnInit {

  @Input() public title: string = 'filters.title';
  @Input() public filters: AttributeFilter[] = [];

  constructor(
    private _modalController: ModalController
  ) { }

  ngOnInit() {
  }

  public save() {
    this.dismiss();
  }

  public clear() {
    for (const f of this.filters) {
      f.clear();
    }
  }

  public close() {
    this.dismiss(true);
  }

  private dismiss(isClose: boolean = false) {
    if (isClose) {
      this._modalController.dismiss(null);
      return;
    }
    this._modalController.dismiss(this.filters);
  }
}
